// **** Constants **** //

export const MAX_TASK_NAME_CHAR_LENGTH = 255;
export const MAX_TASK_DESCRIPTION_CHAR_LENGTH = 100;

export const ADMIN_CONFIG_TABS = {
  Site: 'site-config',
  Task: 'task-config',
  Form: 'form-config',
  FormTaskConfig: 'form-tasks-config',
  Modification: 'modification-config',
} as const;

export const ADMIN_CONFIG_PATHS = {
  Root: '/adminConfiguration',
  Site: `/adminConfiguration/siteConfiguration`,
  Task: '/adminConfiguration/taskConfiguration',
  Form: '/adminConfiguration/restrictionFormConfiguration',
  Modification: '/adminConfiguration/jobModificationConfiguration',
} as const;

export const ADMIN_CONFIG_TASK_TABS = {
  Task: ADMIN_CONFIG_TABS.Task + '-task-table',
  TaskGroup: ADMIN_CONFIG_TABS.Task + '-task-group-table',
} as const;

export const ADMIN_CONFIG_TASK_PATHS = {
  Task: `${ADMIN_CONFIG_PATHS.Task}/task`,
  TaskGroup: `${ADMIN_CONFIG_PATHS.Task}/taskGroup`,
} as const;

// So we don't constantly have to check for undefined
export const AdminConfigTabMap = (() => {
  const map: Map<string, string> = new Map([
    // Tabs to Path
    [ADMIN_CONFIG_TABS.Site, ADMIN_CONFIG_PATHS.Site],
    [ADMIN_CONFIG_TABS.Task, ADMIN_CONFIG_PATHS.Task],
    [ADMIN_CONFIG_TABS.Form, ADMIN_CONFIG_PATHS.Form],
    [ADMIN_CONFIG_TABS.Modification, ADMIN_CONFIG_PATHS.Modification],
    // Paths to Tabs
    [ADMIN_CONFIG_PATHS.Site, ADMIN_CONFIG_TABS.Site],
    [ADMIN_CONFIG_PATHS.Task, ADMIN_CONFIG_TABS.Task],
    [ADMIN_CONFIG_TASK_PATHS.Task, ADMIN_CONFIG_TABS.Task],
    [ADMIN_CONFIG_TASK_PATHS.TaskGroup, ADMIN_CONFIG_TABS.Task],
    [ADMIN_CONFIG_PATHS.Form, ADMIN_CONFIG_TABS.Form],
    [ADMIN_CONFIG_PATHS.Modification, ADMIN_CONFIG_TABS.Modification],
  ]);
  const taskMap: Map<string, string> = new Map([
    [ADMIN_CONFIG_TASK_TABS.Task, ADMIN_CONFIG_TASK_PATHS.Task],
    [ADMIN_CONFIG_TASK_TABS.TaskGroup, ADMIN_CONFIG_TASK_PATHS.TaskGroup],
    [ADMIN_CONFIG_TASK_PATHS.Task, ADMIN_CONFIG_TASK_TABS.Task],
    [ADMIN_CONFIG_TASK_PATHS.TaskGroup, ADMIN_CONFIG_TASK_TABS.TaskGroup],
  ]);
  return {
    get(key: string) {
      return map.get(key) ?? '';
    },
    TaskConfig: {
      get(key: string) {
        return taskMap.get(key) ?? '';
      },
    },
  };
})();
